export enum ROUTES {
	HOME = '/',
	COLLECTIONS = 'collections',
	CAREERS = 'careers',
	ABOUT = 'about',
}
